// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "root-2q2bR";
var _5 = "loader__wrapper-2TBW9";
var _6 = "skeleton__wrapper-2mSxd";
var _7 = "loader-j99Mg";
var _8 = "loader__spinner-2hykV";
var _9 = "empty__wrapper-52Esr";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "root", _5 as "loader__wrapper", _6 as "skeleton__wrapper", _7 as "loader", _8 as "loader__spinner", _9 as "empty__wrapper" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "root": _4, "loader__wrapper": _5, "skeleton__wrapper": _6, "loader": _7, "loader__spinner": _8, "empty__wrapper": _9 }
